import style from "./withStyleReset.module.css";

export const withStyleReset = <T extends object>(
  WrappedComponent: React.ComponentType<T>
) => {
  const styleResetWrapper = (props: T) => {
    return (
      <div className={style.reset}>
        <WrappedComponent {...props} />
      </div>
    );
  };

  styleResetWrapper.displayName = `withStyleReset(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return styleResetWrapper;
};
